export default "__VITE_ASSET__9c02cf8e__"